import { render, staticRenderFns } from "./declareTabs.vue?vue&type=template&id=2d015dfd&scoped=true&"
import script from "./declareTabs.vue?vue&type=script&lang=js&"
export * from "./declareTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d015dfd",
  null
  
)

export default component.exports